module.exports = __webpack_public_path__ + "img/d200912-2.4123a1f0.jpg";